import React, { useState } from "react";
import DataTable from "../../../Components/UI/table/DataTable";
import { useQuery } from "react-query";
import { getTransactions } from "../../../MyApi/transactions";
import { transactionsColumns } from "../financialData";
import Can from "../../../utils/can";
import FilterBar from "../../../Components/UI/filterbar";

const TransactionsTab = () => {
  const [currentTransactions, setCurrentTransactions] = useState(1);
  const [filters, setFilters] = useState({
    search: "",
    store_id: "",
    category_id: "",
    date: ""
  });

  const { data: transactionsData, isLoading: loadingTransactions ,isFetching} = useQuery(
    ["getTransactions", filters, currentTransactions],
    () => getTransactions(currentTransactions, filters)
  );

  const transactions = transactionsData?.data?.transactions || [];
  const totalTransactions = transactionsData?.data?.pagination?.totalItems || 0;
  const last_pageTransactions = transactionsData?.data?.pagination?.last_page || 0;

  const handleFilterChange = (newFilters) => {
    setCurrentTransactions(1); // Reset to first page when filters change
  };

  const handleResetFilters = () => {
    setFilters({
      search: "",
      store_id: "",
      category_id: "",
      date: ""
    });
    setCurrentTransactions(1);
  };

  const filtersConfig = {
    search: true,
    store: true,
    categories: true,
    date: true
  };

  return (
    <Can permission={"view_transaction"}>
      <FilterBar
        filters={filters}
        setFilters={setFilters}
        filtersConfig={filtersConfig}
        placeholder="البحث حسب اسم المتجر..."
        onFilterChange={handleFilterChange}
        onResetFilters={handleResetFilters}
      />
      <DataTable
        columns={transactionsColumns}
        data={transactions || []}
        title="سجل المدفوعات"
        isLoading={loadingTransactions}
        totalItems={totalTransactions}
        itemsPerPage={last_pageTransactions}
        currentPage={currentTransactions}
        setCurrentPage={setCurrentTransactions}
        isFetching={isFetching}
      />
    </Can>
  );
};

export default TransactionsTab;
